import { FaIcon } from '@acp/core-ui';
import { Box, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { faAt, faPhone } from '@fortawesome/pro-solid-svg-icons';

export function ActiveNoticesContactUs() {
    return (
        <Box mt={2}>
            <Text fontSize="small" fontWeight="bold">
                <FaIcon icon={faWarning} color="danger.500" mr={1} />
                Please contact Detector Inspector by phone or email to arrange this service,
                as efforts to contact this tenant and arrange a time has not led to a successful
                booking.
            </Text>
            <Text fontSize="small" mt={2}>
                <FaIcon icon={faPhone} mr={1} />
                1300 134 563
            </Text>
            <Text fontSize="small">
                <FaIcon icon={faAt} mr={1} />
                help@detectorinspector.com.au
            </Text>
        </Box>
    );
}
